/**
 * Testimonials configuration with LinkedIn profiles
 * LinkedIn URLs researched on January 2026
 */

export const TESTIMONIALS = [
  {
    text: {
      paragraph1:
        "Artistiggo consistently delivers high-quality visuals that meet our production standards, and they approach every project with strong work ethics and professionalism.",
      paragraph2:
        "What stands out most is their willingness to tackle any challenge we present them with; whether it's tight deadlines, complex technical requirements, or evolving creative directions. They're reliable partners who understand the demands of game development and execute accordingly. I'd recommend Artistiggo to any studio looking for a dependable co-dev art partner.",
    },
    name: "Raymond DeGuzman",
    position: "Producer @ DreamPlay",
    linkedIn: "https://www.linkedin.com/in/ray-deguzman-73589630",
  },
  {
    text: {
      paragraph1:
        "Working with Artistiggo team has been an excellent experience. They are highly responsive, always available when needed, and deliver updates quickly and efficiently.",
      paragraph2:
        "Communication with the team is smooth, clear, and solution-oriented; a true example of professionalism and reliability in outsourced collaboration.",
    },
    name: "Dragan Jankovic",
    position: "Product Innovation Manager @ Fazi",
    linkedIn: "https://www.linkedin.com/in/dragan-jankovi%C4%87-nis",
  },
  {
    text: {
      paragraph1:
        "We've been working with Artistiggo this year on a number of ambitious game projects and pitches, and we continue to be impressed with the level of collaboration and craft they bring to the table.",
      paragraph2:
        "Numerous clients have come back to say the concept and illustration work produced was beyond their expectations, and that is a result of how effectively they integrate into our workflows, manage feedback, and (of course) bring their A-game to our endeavors every day.",
    },
    name: "Chad Mirshak",
    position: "Chief Design Officer @ Onyx Group",
    linkedIn: "https://www.linkedin.com/in/cmirshak",
  },
  {
    text: {
      paragraph1:
        "Working with this team was an absolute pleasure. From start to finish, everything went smoothly - excellent communication,  quick responses and complete dedication to every detail.",
      paragraph2:
        "Our slot games turned out exactly as we envisioned them. We highly recommend this team without hesitation.",
    },
    name: "Borislav Pavlovic",
    position: "Team Lead @ Alea Partners",
    linkedIn: "https://www.linkedin.com/in/borislav-pavlovic-314156188",
  },
  {
    text: {
      paragraph1:
        "We've partnered with Artistiggo Studio for 2 years now, and their work has consistently impressed us. Starting with small projects, we've gradually expanded the scope as their team grew.",
      paragraph2:
        "Initially, we collaborated closely with their team to define our style, but now we trust them entirely with creative direction. Fantastic team!",
    },
    name: "Cameron Moulene",
    position: "Founder & CEO @ Non Fungible Films",
    linkedIn: "https://www.linkedin.com/in/cameron-moulene-78a027126",
  },
];
